// extracted by mini-css-extract-plugin
export default {"instructionBox":"InustructionsBox_instructionBox__cHvJc"};